import React from "react";

import Layout from "./Layout";

const DbDiagram = ({ imageName }) => {
  return (
    <Layout>
     <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        maxWidth: '100%',
        height: 'auto',
      }}>
        <img style={{
          maxWidth: '100%',
          height: 'auto',
        }} src={require(`../../assets/${imageName}.png`)} alt={imageName} />
      </div>
    </Layout>
  );
};

export default DbDiagram;
